import {
  RemoveEmployeeDialog,
  EditEmployeeDrawer,
  AddEmployeeDrawer,
} from '@pages/employees/containers/employees-list';
import { EmployeesHeader, EmployeesTable } from '@pages/employees/containers';
import { EmployeeTableDataDto } from '@interfaces/models';
import { HasPermission } from '@shared/components';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

export const Employees = () => {
  const location = useLocation();

  const [isAddEmployeeDrawerOpen, setIsAddEmployeeDrawerOpen] = useState(false);
  const [isRemoveEmployeeDialogOpen, setIsRemoveEmployeeDialogOpen] = useState(false);
  const [isEditEmployeeDrawerOpen, setIsEditEmployeeDrawerOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState<EmployeeTableDataDto | null>(null);

  const handleOpenRemoveEmployeeDialog = (employee: EmployeeTableDataDto) => {
    setIsRemoveEmployeeDialogOpen(true);
    setSelectedEmployee(employee);
  };

  const handleOpenEditEmployeeDrawer = (employee: EmployeeTableDataDto) => {
    setSelectedEmployee(employee);
    setIsEditEmployeeDrawerOpen(true);
  };

  const handleCloseEditEmployeeDrawer = () => {
    setIsEditEmployeeDrawerOpen(false);
    setSelectedEmployee(null);
  };

  const handleCloseRemoveEmployeeDialog = ({ employeeRemoved }: { employeeRemoved: boolean }) => {
    if (!isEditEmployeeDrawerOpen) setSelectedEmployee(null);
    if (employeeRemoved) handleCloseEditEmployeeDrawer();

    setIsRemoveEmployeeDialogOpen(false);
  };

  useEffect(() => {
    if (location.state?.openEmployeeDrawer) {
      setIsAddEmployeeDrawerOpen(true);
    }
  }, [location.state]);

  return (
    <HasPermission permissionFeature="EMPLOYEES" permissionType="READ" redirect>
      <EmployeesHeader onAddEmployee={() => setIsAddEmployeeDrawerOpen(true)} />
      <EmployeesTable
        onOpenRemoveEmployeeDialog={handleOpenRemoveEmployeeDialog}
        onOpenEditEmployeeDrawer={handleOpenEditEmployeeDrawer}
      />

      <RemoveEmployeeDialog
        selectedEmployeeId={selectedEmployee?.id ?? ''}
        onClose={handleCloseRemoveEmployeeDialog}
        isOpen={isRemoveEmployeeDialogOpen}
      />

      <AddEmployeeDrawer
        onClose={() => setIsAddEmployeeDrawerOpen(false)}
        isOpen={isAddEmployeeDrawerOpen}
      />

      <EditEmployeeDrawer
        onOpenRemoveEmployeeDialog={handleOpenRemoveEmployeeDialog}
        onClose={handleCloseEditEmployeeDrawer}
        selectedEmployee={selectedEmployee!}
        isOpen={isEditEmployeeDrawerOpen}
      />
    </HasPermission>
  );
};
